/* eslint-disable global-require */
import _ from 'lodash';
import { createStore, applyMiddleware, compose } from 'redux';
import { combineReducers } from 'redux-immutablejs';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import thunk from 'redux-thunk';

import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import airbrakeMiddleware from '../../reduxMiddlewares/airbrakeMiddleware';
import apiRequestMiddleware from '../../reduxMiddlewares/apiRequestMiddleware';
import authMiddleware from '../../reduxMiddlewares/authMiddleware';
import redirectMiddleware from '../../reduxMiddlewares/redirectMiddleware';
import gaMiddleware from '../../reduxMiddlewares/gaMiddleware';
import analyticsMiddleware from '../../reduxMiddlewares/analyticsMiddleware';

/**
 * @param  {object} initialState - initial state (@see redux.createStore(), second argument)
 * @param  {object} apiClient - we inject the httpClient for easier mocking
 *                            plus easily changing http library on client and server.
 *                            (note - this will change with webpack build)
 * @param  {boolean} enableWebpackHMR - whether to enable hot module reloading (@see config)
 *
 * @return {object} - redux stored with all the initial data loaded
 */
export default function createReduxStore(
  initialState,
  apiClient,
  enableWebpackHMR = false,
  enableReduxDevTools = false,
  errorService
) {
  let rootEpic = (...args) => combineEpics(require('app/epics/itemLevelHoldExceptionEpic').default)(...args, apiClient);
  const epicMiddleware = createEpicMiddleware(rootEpic);
  const middlewares = [
    authMiddleware,
    apiRequestMiddleware(apiClient),
    epicMiddleware,
    redirectMiddleware,
    thunk.withExtraArgument(apiClient),
    airbrakeMiddleware(errorService),
    gaMiddleware(BCGoogleAnalyticsUtils),
    analyticsMiddleware()
  ];

  let combinedReducers = combineReducers(require('../../reducers').default);
  const lastCreatedStore = createStore(
    combinedReducers,
    initialState,
    compose(
      applyMiddleware(..._.compact(middlewares)),
      enableReduxDevTools && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );

  if (enableWebpackHMR && module.hot) {
    module.hot.accept('../../reducers', () => {
      combinedReducers = combineReducers(require('../../reducers').default);
      rootEpic = combineEpics(..._.values(require('../../epics')));
      lastCreatedStore.replaceReducer(combinedReducers);
      epicMiddleware.replaceEpic(rootEpic);
    });
  }

  return lastCreatedStore;
}
